import React from "react";

import classNames from "classnames";
import { motion } from "framer-motion";

import { useSidebarState } from "contexts/sidebar";
import useAutoCollapse from "hooks/useAutoCollapse";

const ExploreContainer = ({ children, className }) => {
  const { isExpanded } = useSidebarState();

  useAutoCollapse();

  const variants = {
    collapsed: {
      width: "calc(100vw - 80px - 350px)",
    },
    expanded: {
      width: "calc(100vw - 320px - 350px)",
    },
  };
  return (
    <motion.div
      animate={isExpanded ? "expanded" : "collapsed"}
      initial={isExpanded ? "expanded" : "collapsed"}
      variants={variants}
      transition={{ duration: 0.3 }}
      className={classNames(
        "cs-ui-explore-container cs-ui-explore-container__wrapper",
        className
      )}
      data-testid="explore-container"
    >
      {children}
    </motion.div>
  );
};

export default ExploreContainer;
